/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChartFilterOptionDto } from './ChartFilterOptionDto';
import {
    ChartFilterOptionDtoFromJSON,
    ChartFilterOptionDtoFromJSONTyped,
    ChartFilterOptionDtoToJSON,
    ChartFilterOptionDtoToJSONTyped,
} from './ChartFilterOptionDto';

/**
 * A filter configuration for a chart
 * @export
 * @interface ChartFilterDto
 */
export interface ChartFilterDto {
    /**
     * Unique identifier for this filter
     * @type {string}
     * @memberof ChartFilterDto
     */
    id: string;
    /**
     * Display label for this filter
     * @type {string}
     * @memberof ChartFilterDto
     */
    label: string;
    /**
     * Default selected value
     * @type {string}
     * @memberof ChartFilterDto
     */
    defaultValue?: string;
    /**
     * Available filter options
     * @type {Array<ChartFilterOptionDto>}
     * @memberof ChartFilterDto
     */
    options: Array<ChartFilterOptionDto>;
}

/**
 * Check if a given object implements the ChartFilterDto interface.
 */
export function instanceOfChartFilterDto(value: object): value is ChartFilterDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function ChartFilterDtoFromJSON(json: any): ChartFilterDto {
    return ChartFilterDtoFromJSONTyped(json, false);
}

export function ChartFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'options': ((json['options'] as Array<any>).map(ChartFilterOptionDtoFromJSON)),
    };
}

export function ChartFilterDtoToJSON(json: any): ChartFilterDto {
    return ChartFilterDtoToJSONTyped(json, false);
}

export function ChartFilterDtoToJSONTyped(value?: ChartFilterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'defaultValue': value['defaultValue'],
        'options': ((value['options'] as Array<any>).map(ChartFilterOptionDtoToJSON)),
    };
}

